import { Box, Flex, Image, Stack, Text, Tooltip } from '@mantine/core'
import classes from './DataGridPerson.module.css'
import cn from 'classnames'

export interface DataGridPersonProps {
  name: string
  status?: 'online' | 'offline'
  image?: string
  onClick?: (person?: any) => void
}

export const DataGridPerson = (props: DataGridPersonProps) => {
  const { name, status, image, onClick = () => {} } = props

  return (
    <Flex
      className={classes.DataGridPerson}
      align="center"
      gap="xs"
      onClick={onClick}
    >
      {image && (
        <Box className={classes.DataGridPerson__photo}>
          <Image src={image} w={30} h={30} />
          {status && (
            <Tooltip label={<Text tt="capitalize">{status}</Text>}>
              <div
                className={cn(classes.DataGridPerson__status, {
                  [classes.DataGridPerson__statusOnline]: status === 'online',
                  [classes.DataGridPerson__statusOffline]: status === 'offline',
                })}
              />
            </Tooltip>
          )}
        </Box>
      )}

      <Text size="sm" c="#000">
        {name}
      </Text>
    </Flex>
  )
}
